import { List, Map } from 'immutable'
import { any, IOWidget, Action, async, nothing, some } from 'widgets-for-react'
import { TemplateState, Page, TemplateProps } from './types.gen'
import { BlockData, ImageSize } from '../blocks/types.gen'

export const PageTemplateComponent = <
  StandardBlocks,
  CustomBlocks extends { kind: CustomBlocks['kind'] },
  CustomBlockData extends { kind: CustomBlockData['kind'] },
  extra_images,
  CustomPageData,
  PublicState
>(
  props: TemplateProps<StandardBlocks, CustomBlocks, CustomBlockData, extra_images, CustomPageData, PublicState>,
  public_state:PublicState
): IOWidget<
  TemplateState<CustomBlockData, CustomBlocks, StandardBlocks, extra_images, CustomPageData>,
  Action<TemplateState<CustomBlockData, CustomBlocks, StandardBlocks, extra_images, CustomPageData>>
> => s0 =>
  any<Action<TemplateState<CustomBlockData, CustomBlocks, StandardBlocks, extra_images, CustomPageData>>>()([
    async<Page<CustomBlocks, StandardBlocks, CustomPageData>>(_ => nothing(), {
      loading: _ => props.loadingPage,
      connectionError: props.errorPage,
      otherError: props.errorPage
    })(s0.page).map<Action<TemplateState<CustomBlockData, CustomBlocks, StandardBlocks, extra_images, CustomPageData>>>(
      updatePage => s1 => {
        let newPage = updatePage(s1.page)
        let images = s1.images
        let blocks = s1.blocks
        let custom_page_data = s1.custom_page_data
        if (newPage.kind === 'loaded') {
          newPage.value.blocks.forEach(b => {
            let images_to_load = props.StandardBlockImagesLoader(b, props.CustomBLockImagesLoader)
            images_to_load.forEach(i => {
              if (!images.has(i.fst)) {
                images = images.set(i.fst, i.snd)
              }
            })
          })
          let extra_data = newPage.value.extra_data
          blocks = Map<number, BlockData<CustomBlockData, extra_images> | CustomBlockData>(
            List(newPage.value.blocks).flatMap((b, i: number) => {
              let res = props.StandardBlock_To_Widget(
                b,
                i,
                extra_data,
                props.CustomBlock_To_Widget
                // props.acceptAllCookies,
                // props.getCookie,
                // props.videoCookie
              )
              return res.v.kind === 'l' ? [] : [[i, res.v.v]]
            }) as any // TOOD: ugly fix
          )
          custom_page_data = some(newPage.value.extra_data)
        }
        return { ...s1, blocks: blocks, images: images, page: newPage, custom_page_data:custom_page_data }
      }
    ),
    s0.page.kind == 'loaded' ? props.Display(props.pageDisplay(s0.page.value.blocks, public_state)(s0)) : nothing(),

    ...s0.images
      .map((e, i) =>
        async<Map<ImageSize<extra_images>, string>>(_ => nothing())(e).map<
          Action<TemplateState<CustomBlockData, CustomBlocks, StandardBlocks, extra_images, CustomPageData>>
        >(a => s => ({ ...s, images: s.images.set(i, a(s.images.get(i))) }))
      )
      .valueSeq()
      .toArray()
  ])
